import React, { useState } from "react";
import s from "./ErrorLoading.module.scss";
import Lottie from "lottie-react";
import loading from "./AnimationJson/loading.json";
import { useMediaQuery } from "react-responsive";
import { TypeAnimation } from "react-type-animation";

export const ErrorFallbackLoadingScreen = ({ progress, widthProgress }) => {
  //const [progress, setProgress] = useState(60);
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const isRoundCorner = widthProgress === 100;
  return (
    <section className={s.error_loading__section}>
      <div className={s.error_loading__content}>
        <h4 className={s.error_loading__title}>Awesome Tech</h4>
        <h3 className={s.error_loading__loading}>Loading...</h3>
      </div>
      <div className={s.error_wait}>
        <div className={s.line}></div>
        <p className={s.error_wait__title}>Please wait</p>
        <div className={s.line}></div>
      </div>

      <div className={s.progress_block}>
        <div className={s.progress_bar}>
          <div
            className={s.progress_inner}
            style={
              isRoundCorner
                ? { width: `${widthProgress}%`, borderRadius: "9px" }
                : {
                    width: `${widthProgress}%`,
                    borderRight: "7px solid #18C829",
                    boxShadow:
                      "2px 0 5px -2px rgba(24, 200, 41, 0.50)" /* Adjust the shadow color and size as needed */,
                  }
            }
          >
            {`${progress}%`}
          </div>
        </div>
      </div>
      <div className={s.loading_wrap}>
        <div className={s.loading_block}>
          <div className={s.setting_block}>
            {isMobile ? (
              <div className={s.setting_icon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_59_500)">
                    <path
                      d="M8.43066 0.500001C8.65116 0.500001 8.84841 0.637251 8.92266 0.842751L9.45216 2.3105C9.64191 2.35775 9.80466 2.405 9.94266 2.4545C10.0934 2.5085 10.2877 2.59025 10.5277 2.702L11.7607 2.0495C11.8613 1.99618 11.9765 1.97693 12.089 1.99465C12.2015 2.01236 12.3053 2.06608 12.3847 2.14775L13.4692 3.269C13.6132 3.41825 13.6537 3.6365 13.5727 3.827L12.9944 5.18225C13.0904 5.3585 13.1669 5.50925 13.2254 5.63525C13.2884 5.7725 13.3664 5.9615 13.4594 6.20525L14.8072 6.78275C15.0097 6.869 15.1349 7.0715 15.1214 7.28825L15.0224 8.8445C15.0156 8.9456 14.9793 9.0425 14.918 9.12316C14.8567 9.20382 14.773 9.2647 14.6774 9.29825L13.4009 9.752C13.3642 9.92825 13.3259 10.079 13.2854 10.2065C13.2201 10.4034 13.1455 10.5971 13.0619 10.787L13.7032 12.2045C13.7484 12.3041 13.7606 12.4156 13.7379 12.5226C13.7153 12.6296 13.6589 12.7266 13.5772 12.7993L12.3577 13.8883C12.2774 13.9597 12.1771 14.0048 12.0704 14.0177C11.9637 14.0306 11.8557 14.0105 11.7607 13.9603L10.5037 13.2943C10.307 13.3984 10.1041 13.4903 9.89616 13.5695L9.34716 13.775L8.85966 15.125C8.82354 15.2239 8.75837 15.3095 8.67271 15.3707C8.58705 15.4318 8.4849 15.4657 8.37966 15.4678L6.95466 15.5C6.84663 15.5028 6.74038 15.4721 6.65053 15.4121C6.56068 15.352 6.49164 15.2656 6.45291 15.1648L5.87841 13.6445C5.6824 13.5775 5.48832 13.505 5.29641 13.427C5.13945 13.3591 4.98486 13.2858 4.83291 13.2073L3.40791 13.8163C3.31402 13.8563 3.2105 13.8682 3.10997 13.8505C3.00943 13.8328 2.91622 13.7862 2.84166 13.7165L1.78716 12.7273C1.70865 12.6539 1.65519 12.5578 1.63433 12.4524C1.61346 12.347 1.62626 12.2377 1.67091 12.14L2.28366 10.805C2.20217 10.6469 2.12662 10.4858 2.05716 10.322C1.97609 10.1216 1.90105 9.91871 1.83216 9.71375L0.489663 9.305C0.380538 9.27202 0.285359 9.20393 0.218905 9.1113C0.152452 9.01867 0.118444 8.90669 0.122163 8.79275L0.174663 7.352C0.1784 7.258 0.207765 7.1668 0.259584 7.08828C0.311402 7.00976 0.383702 6.9469 0.468663 6.9065L1.87716 6.23C1.94241 5.99075 1.99941 5.80475 2.04966 5.669C2.12042 5.48769 2.19899 5.30952 2.28516 5.135L1.67466 3.845C1.62833 3.74704 1.61426 3.63691 1.63448 3.53044C1.65469 3.42398 1.70815 3.32667 1.78716 3.2525L2.84016 2.258C2.91398 2.18838 3.00634 2.14157 3.10613 2.12321C3.20593 2.10485 3.3089 2.11572 3.40266 2.1545L4.82616 2.7425C4.98366 2.6375 5.12616 2.55275 5.25516 2.4845C5.40891 2.40275 5.61441 2.31725 5.87316 2.225L6.36816 0.844251C6.40476 0.743203 6.47165 0.655912 6.55971 0.5943C6.64776 0.532687 6.75269 0.499755 6.86016 0.500001H8.43066ZM7.64016 5.76425C6.38991 5.76425 5.37666 6.7655 5.37666 8.0015C5.37666 9.2375 6.38991 10.2395 7.64016 10.2395C8.88966 10.2395 9.90291 9.2375 9.90291 8.0015C9.90291 6.7655 8.89041 5.76425 7.64016 5.76425Z"
                      fill="#13B222"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_59_500">
                      <rect
                        width="15"
                        height="15"
                        fill="white"
                        transform="translate(0.121887 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            ) : (
              <div className={s.setting_icon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_56_108)">
                    <path
                      d="M11.5784 1.82514e-06C11.8724 1.82514e-06 12.1354 0.183002 12.2344 0.457002L12.9404 2.414C13.1934 2.477 13.4104 2.54 13.5944 2.606C13.7954 2.678 14.0544 2.787 14.3744 2.936L16.0184 2.066C16.1526 1.99491 16.3062 1.96925 16.4562 1.99287C16.6062 2.01649 16.7445 2.08811 16.8504 2.197L18.2964 3.692C18.4884 3.891 18.5424 4.182 18.4344 4.436L17.6634 6.243C17.7914 6.478 17.8934 6.679 17.9714 6.847C18.0554 7.03 18.1594 7.282 18.2834 7.607L20.0804 8.377C20.3504 8.492 20.5174 8.762 20.4994 9.051L20.3674 11.126C20.3583 11.2608 20.3099 11.39 20.2282 11.4975C20.1464 11.6051 20.0349 11.6863 19.9074 11.731L18.2054 12.336C18.1564 12.571 18.1054 12.772 18.0514 12.942C17.9643 13.2045 17.8648 13.4628 17.7534 13.716L18.6084 15.606C18.6687 15.7388 18.685 15.8874 18.6547 16.0301C18.6245 16.1728 18.5494 16.3021 18.4404 16.399L16.8144 17.851C16.7073 17.9462 16.5737 18.0064 16.4314 18.0236C16.2891 18.0408 16.145 18.014 16.0184 17.947L14.3424 17.059C14.0802 17.1978 13.8096 17.3204 13.5324 17.426L12.8004 17.7L12.1504 19.5C12.1022 19.6318 12.0153 19.746 11.9011 19.8276C11.7869 19.9091 11.6507 19.9542 11.5104 19.957L9.61037 20C9.46633 20.0038 9.32466 19.9628 9.20486 19.8828C9.08505 19.8027 8.993 19.6875 8.94137 19.553L8.17537 17.526C7.91401 17.4367 7.65524 17.34 7.39937 17.236C7.19008 17.1454 6.98396 17.0477 6.78137 16.943L4.88137 17.755C4.75618 17.8084 4.61816 17.8243 4.48411 17.8007C4.35006 17.7771 4.22577 17.715 4.12637 17.622L2.72037 16.303C2.61569 16.2052 2.5444 16.077 2.51658 15.9365C2.48877 15.796 2.50583 15.6503 2.56537 15.52L3.38237 13.74C3.27371 13.5292 3.17297 13.3144 3.08037 13.096C2.97227 12.8287 2.87222 12.5583 2.78037 12.285L0.990367 11.74C0.844868 11.696 0.717962 11.6052 0.629357 11.4817C0.540753 11.3582 0.495409 11.2089 0.500367 11.057L0.570367 9.136C0.57535 9.01066 0.614504 8.88907 0.683595 8.78438C0.752687 8.67968 0.849086 8.59587 0.962367 8.542L2.84037 7.64C2.92737 7.321 3.00337 7.073 3.07037 6.892C3.16471 6.65025 3.26947 6.41269 3.38437 6.18L2.57037 4.46C2.50859 4.32938 2.48983 4.18254 2.51679 4.04059C2.54374 3.89864 2.61502 3.76889 2.72037 3.67L4.12437 2.344C4.22279 2.25117 4.34594 2.18876 4.479 2.16428C4.61205 2.1398 4.74935 2.15429 4.87437 2.206L6.77237 2.99C6.98237 2.85 7.17237 2.737 7.34437 2.646C7.54937 2.537 7.82337 2.423 8.16837 2.3L8.82837 0.459002C8.87716 0.32427 8.96635 0.207883 9.08376 0.125733C9.20117 0.0435827 9.34107 -0.000326251 9.48437 1.82514e-06H11.5784ZM10.5244 7.019C8.85737 7.019 7.50637 8.354 7.50637 10.002C7.50637 11.65 8.85737 12.986 10.5244 12.986C12.1904 12.986 13.5414 11.65 13.5414 10.002C13.5414 8.354 12.1914 7.019 10.5244 7.019Z"
                      fill="#13B222"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_56_108">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
          </div>
          <div className={s.loading_content}>
            {/* <p className={s.loading_text}>
              Loading some Crazy AI speaking models
            </p> */}
            <TypeAnimation
              sequence={[
                "Loading AI model for IELTS Mock Test simulation...", // Types 'One'
                2000, // Waits 1s
                "Deploying advanced SOP Writer neural networks...", // Deletes 'One' and types 'Two'
                2000, // Waits 2s
                "Updating real-time global university data feeds...",
                2000, // Types 'Three' without deleting 'Two'
                "Loading AI model for university recommendation engine...",
              ]}
              wrapper="span"
              cursor={true}
              className={s.loading_text}
              repeat={Infinity}
            />
          </div>
        </div>
      </div>
      <Lottie
        style={
          isMobile
            ? {
                position: "absolute",
                bottom: "3px",
                width: "335px",
                left: "50%",
                transform: "translateX(-50%)",
              }
            : {
                width: "430px",
                position: "absolute",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
              }
        }
        animationData={loading}
      />
    </section>
  );
};
